import _ from '@/utils/lodash-optimized'

const MAGIC_JSON_INDICATOR_UGLY_BUT_QUICK_FIX = '\r\r\r\t\t\t'

// generate QuestionnaireResponse object from form answers
export const generateQuestionnaireResponse = (
  formData,
  category,
  currentUser
) => {
  const result = {
    resourceType: 'QuestionnaireResponse',
    status: 'in-progress',
    authored: new Date(),
    contained: [
      {
        resourceType: 'Questionnaire',
        id: category,
        status: 'published'
      }
    ],
    text: {
      status: 'generated',
      div: '<div></div>'
    },
    questionnaire: {
      reference: `http://narus.com/Questionnaire/${category}`
    },
    author: { reference: `Practitioner/${currentUser.id}` },
    item: []
  }


  for (const item in formData) {
    if (Object.prototype.hasOwnProperty.call(formData, item)) {
      const value = formData[item]

      let answer = null

      if (_.isObject(value) || _.isArray(value)) {
        answer =
          MAGIC_JSON_INDICATOR_UGLY_BUT_QUICK_FIX + JSON.stringify(value)
      } else if (_.isNil(value)) {
        answer = null
      } else {
        answer = String(value)
      }

      if (!_.isNil(answer)) {
        result.item.push({
          linkId: item,
          text: item,
          answer: [{ valueString: answer }]
        })
      }
    }
    return result
  }
}

// pre-populate a form from the QuestionnaireResponse
export const generateFormFromQuestionnaireResponse = data => {
  const result = {}
    const questions = data?.questionnaireResponse?.item || []
    result.authored = data?.questionnaireResponse?.authored

  questions.forEach(q => {
      const answer = q?.answer?.[0]?.valueString
    let value = null

    if (
      answer.substring(0, MAGIC_JSON_INDICATOR_UGLY_BUT_QUICK_FIX.length) ===
      MAGIC_JSON_INDICATOR_UGLY_BUT_QUICK_FIX
    ) {
      value = JSON.parse(
        answer.substring(MAGIC_JSON_INDICATOR_UGLY_BUT_QUICK_FIX.length)
      )
    } else {
      value = answer
    }

    if (value === 'undefined' || value === '') {
      value = null
    }

    result[q.linkId] = value
  })

  return result
}
